import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
  faReceipt,
} from '@fortawesome/pro-light-svg-icons'

import { Button, Tools } from '@domain-group/suit-theme'

import useOrder from '@hooks/useOrder'

import AuthenticatedDownload from '@components/AuthenticatedDownload'
import ScopedConditionalContent from '@components/ScopedConditionalContent'

const OrderTools = () => {
  const useOrderPayload = useOrder()
  const { urls: { approvedOrdersCsv } } = useOrderPayload

  return (
    <ScopedConditionalContent permittedRoleTitles={['Provider Director', 'Provider Employee']}>
      <Tools>
        <AuthenticatedDownload>
          <Button
            buttonStyle="secondaryUtility"
            icon={<FontAwesomeIcon icon={faReceipt} />}
            size="medium"
            // @ts-expect-error TS2322
            href={approvedOrdersCsv}
          >
            Download Approved Orders
          </Button>
        </AuthenticatedDownload>
      </Tools>
    </ScopedConditionalContent>
  )
}

export default OrderTools
